"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
const react_1 = __importDefault(require("react"));
exports.Tabs = (props) => react_1.default.createElement("div", { className: 'tabs' }, props.children);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGFicy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9sYXlvdXQvVGFicy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsa0RBRXNDO0FBRXpCLFFBQUEsSUFBSSxHQUFzQixDQUFDLEtBQUssRUFBRSxFQUFFLENBQzdDLHVDQUFLLFNBQVMsRUFBQyxNQUFNLElBQ2YsS0FBSyxDQUFDLFFBQVEsQ0FDZCxDQUFDIn0=